var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1627 18.2372C24.7658 16.7813 25.0762 15.2209 25.0762 13.645C25.0762 10.4624 23.8119 7.41017 21.5615 5.15974C19.311 2.9093 16.2588 1.64502 13.0762 1.64502C9.89357 1.64502 6.84133 2.9093 4.59089 5.15974C2.34045 7.41017 1.07617 10.4624 1.07617 13.645C1.07617 15.2209 1.38656 16.7813 1.98962 18.2372C2.59267 19.6931 3.47659 21.016 4.59089 22.1303C5.70519 23.2446 7.02806 24.1285 8.48397 24.7316C9.93988 25.3346 11.5003 25.645 13.0762 25.645C14.652 25.645 16.2125 25.3346 17.6684 24.7316C19.1243 24.1285 20.4471 23.2446 21.5615 22.1303C22.6758 21.016 23.5597 19.6931 24.1627 18.2372Z",
    fill: "#0C1318",
    fillOpacity: 0.7,
    stroke: "#71AAFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07617 13.6452L11.7428 16.3118L17.0762 10.9785",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e24b41adc85e75510b3eea74a2cbf6c5.svg";
export { ForwardRef as ReactComponent };